import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ThemeService } from '@vendorhub/shared/ui';

@Component({
  selector: 'vh-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header class="vh-nav" [class.vh-nav--open]="menuOpen()">
      <div class="vh-nav__inner">
        <a class="vh-nav__logo" routerLink="/"> <span>Vendor</span><strong>Hub</strong> </a>

        <nav class="vh-nav__links" aria-label="Marketplace navigation">
          <a routerLink="/vendors" routerLinkActive="is-active">Browse Vendors</a>
          <a routerLink="/vendors" [queryParams]="{ category: 'photography' }">Categories</a>
          <a routerLink="/vendors" [queryParams]="{ intent: 'requirement' }">Post Requirement</a>
          <a routerLink="/vendors" [queryParams]="{ badge: 'premium' }">Premium Vendors</a>
        </nav>

        <div class="vh-nav__actions">
          <button
            type="button"
            class="vh-nav__theme"
            aria-label="Toggle theme"
            (click)="theme.toggle()"
          >
            {{ theme.isDark() ? 'Light' : 'Dark' }}
          </button>

          <a routerLink="/vendors" [queryParams]="{ intent: 'join-vendor' }" class="vh-nav__join">
            Join as Vendor
          </a>

          <button
            type="button"
            class="vh-nav__burger"
            aria-label="Toggle navigation"
            (click)="toggleMenu()"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </header>
  `,
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  readonly theme = inject(ThemeService);

  private readonly _menuOpen = signal(false);
  readonly menuOpen = this._menuOpen.asReadonly();

  toggleMenu(): void {
    this._menuOpen.update((value) => !value);
  }
}
